import {
  skipToken,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { addMemberTrait, getAllTraits, getMemberTraits } from "./traits"
import { traitKeys } from "./queryKeys"
import { deleteMemberTrait } from "@apis/traits/traits"

export const useGetAllTraitsQuery = () => {
  return useQuery({
    queryKey: traitKeys.all,
    queryFn: getAllTraits,
  })
}

export const useGetMemberTraitsQuery = (prospect_guid: string | undefined) => {
  return useQuery({
    queryKey: traitKeys.memberTraits(prospect_guid),
    queryFn: prospect_guid ? () => getMemberTraits(prospect_guid) : skipToken,
  })
}

export const useAddTraitMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addMemberTrait,
    onSuccess: (_, { prospect_guid }) => {
      queryClient.invalidateQueries({
        queryKey: traitKeys.memberTraits(prospect_guid),
      })
    },
  })
}

export const useDeleteMemberTraitMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteMemberTrait,
    onSuccess: (_, { prospect_guid }) => {
      queryClient.invalidateQueries({
        queryKey: traitKeys.memberTraits(prospect_guid),
      })
    },
  })
}
